import { httpClientBanking } from '~/domains/banking/shared/infra/http-client-banking'
import { type UseMutationRequestOptions, useMutationRequest } from '~/ui/hooks/utils/service/use-query-request'

import { type CreateBucketParams, type CreateBucketResponse, CreateBucketResponseSchema } from './definitions'

async function createBucket({ accountId, name, category }: CreateBucketParams) {
  const res = await httpClientBanking({
    url: `/investments/accounts/${accountId}/buckets`,
    method: 'POST',
    data: { name, category }
  })

  const data = CreateBucketResponseSchema.parse(res.data)

  return data
}

export function useCreateBucket(
  config?: UseMutationRequestOptions<CreateBucketResponse, unknown, true, CreateBucketParams>
) {
  return useMutationRequest<CreateBucketResponse, unknown, true, CreateBucketParams>(
    ['useCreateBucket'],
    createBucket,
    config
  )
}
